import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/inventory/AjusteMasivo',
  documento: 'inventory',
  acceso: 'sesion',
  filas: ['039'],
  cita: 'Areas/Inventory/Controllers/InventoryController.cs:272',
} satisfies RutaProd;
